import dayjs from "dayjs";
import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DateRange } from "@/domains/common";
import {
  TransferRead,
  TransferService,
  TransferQueryParams,
  TransferCategory,
} from "@/domains/transfer";
import { RootState } from "@/stores";

interface OperatorTenantWithdrawState {
  loading: boolean;
  dateRange: DateRange;
  queryParams: TransferQueryParams;
  transfers: TransferRead[];
}

const initialState: OperatorTenantWithdrawState = {
  loading: false,
  dateRange: DateRange.day0,
  queryParams: {
    created_started_at: dayjs().startOf("day").toISOString(),
    created_stopped_at: dayjs().endOf("day").toISOString(),
  },
  transfers: [],
};

export const operatorTenantWithdrawSelects = {
  loading: (state: RootState) => state.operatorTenantWithdraw.loading,
  dateRange: (state: RootState) => state.operatorTenantWithdraw.dateRange,
  queryParams: (state: RootState) => state.operatorTenantWithdraw.queryParams,
  transfers: (state: RootState) => state.operatorTenantWithdraw.transfers,
};

export const operatorTenantWithdrawThunks = {
  list: createAsyncThunk(
    "operatorTenantWithdraw/list",
    async (params: TransferQueryParams = {}) => {
      const res = await TransferService.list({
        ...params,
        category: TransferCategory.TenantWithdraw,
      }).run();

      return res.data.msg;
    }
  ),
};

export const operatorTenantWithdrawSlice = createSlice({
  name: "operatorTenantWithdraw",
  initialState,
  reducers: {
    setQueryParams: (state, action: PayloadAction<TransferQueryParams>) => {
      state.queryParams = action.payload;
    },
    setDateRange: (state, action: PayloadAction<DateRange>) => {
      state.dateRange = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(operatorTenantWithdrawThunks.list.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      operatorTenantWithdrawThunks.list.fulfilled,
      (state, action) => {
        state.loading = false;
        state.transfers = action.payload.transfers;
      }
    );
    builder.addCase(operatorTenantWithdrawThunks.list.rejected, (state) => {
      state.loading = false;
      state.transfers = [];
    });
  },
});

export const operatorTenantWithdrawActions =
  operatorTenantWithdrawSlice.actions;
